import cn from 'classnames';

import DefaultLink from 'components/common/DefaultLink';
import { TERMS_PATH } from 'lib/constants/routingConstants';
import { Statuses } from 'lib/constants/signUp';

const TermsOfService = ({ classNames = '', text, location }) => (
  <DefaultLink
    isExternal
    to={TERMS_PATH}
    target="_blank"
    className={cn(classNames, 'inline p-0', {
      textSm: location !== Statuses.BILLING_STEP,
    })}
  >
    {text}
  </DefaultLink>
);

TermsOfService.propTypes = {
  classNames: PropTypes.string,
  text: PropTypes.string,
  location: PropTypes.string,
};

export default TermsOfService;
